<h1>
  {{'PORTAL_ERROR.NOT_FOUND_ERR' | translate:locale.language}}
</h1>
